/* eslint-disable react/prop-types */
import React from 'react'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'
import RadioGroup from './../formik/RadioGroup'
import { Field } from 'formik'
import ContextHelpContainer from '../ContextHelp'
import xyzReaderParameterTranslations from './translations/xyzReaderParameterTranslations'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    darkGrey?: { main: string }
  }
}

const StyledTitleContainer = styled('div')({
  display: 'flex'
})

const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(0),
  paddingTop: theme.spacing(1)
}))

const StyledDisabledTitle = styled(Typography)(({ theme }) => {
  const t = theme as MikeTheme
  return {
    paddingBottom: theme.spacing(0),
    paddingTop: theme.spacing(1),
    color: t.palette.darkGrey?.main ?? '#666'
  }
})

const StyledSubTitle = styled(Typography)(({ theme }) => {
  const t = theme as MikeTheme
  return {
    fontSize: '0.75rem',
    color: t.palette.darkGrey?.main ?? '#666'
  }
})

const StyledColorField = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  '& .MuiTypography-root, .MuiTypography-root.Mui-disabled, .MuiFormControlLabel-root': {
    color: theme.palette.primary.main
  }
}))

const StyledDisabledColorField = styled('div')(({ theme }) => ({
  color: theme.palette.primary.light,
  '& .MuiTypography-root, .MuiTypography-root.Mui-disabled, .MuiFormControlLabel-root': {
    color: theme.palette.primary.light
  }
}))

interface IProps {
  name: string
  disabled?: boolean
}

/* The XYZ Reader expects the
- x coordinate in the first column ( = column index 0),
- the y coordinate in the second column  (= column index 1),
- the connectivity column in third or fourth column ( = column index 2 or 3)
- the z column index in third or fourth column ( = column index 2 or 3)
- or if you do not specify the connectivity index in third column (column index 2) */
const DatasetXYZParameters = (props: IProps) => {
  const { name, disabled } = props

  const TitleComponent = disabled ? StyledDisabledTitle : StyledTitle
  const FieldWrapper = disabled ? StyledDisabledColorField : StyledColorField

  return (
    <>
      <StyledTitleContainer>
        <div>
          <TitleComponent variant="body2">
            {xyzReaderParameterTranslations.title}
          </TitleComponent>
          <StyledSubTitle>
            {xyzReaderParameterTranslations.subTitle}
          </StyledSubTitle>
        </div>
        <ContextHelpContainer
          disabled={disabled}
          helpTexts={[xyzReaderParameterTranslations.info]}
        />
      </StyledTitleContainer>

      <FieldWrapper>
        <Field
          name={name}
          options={[
            { value: 'xycz', label: xyzReaderParameterTranslations.xyczOption },
            { value: 'xyzc', label: xyzReaderParameterTranslations.xyzcOption },
            { value: 'xyc', label: xyzReaderParameterTranslations.xycOption },
            { value: 'xyz', label: xyzReaderParameterTranslations.xyzOption },
            { value: 'xy', label: xyzReaderParameterTranslations.xyOption }
          ]}
          disabled={disabled}
          component={RadioGroup}
        />
      </FieldWrapper>
    </>
  )
}

export default DatasetXYZParameters
